import { createFileRoute } from "@tanstack/react-router"
import { CommunicationMessagesPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/messages"
)({
  component: () => (
    <AuthorizationGate
      resource={Resource.COMMUNICATION_TEMPLATES}
      action={Action.READ}
    >
      <CommunicationMessagesPage />
    </AuthorizationGate>
  ),
})
